// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1bzKG","header":"PatientQuestionnaire_header__2x6iC","info":"PatientQuestionnaire_info__3xlwS"};